var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-5"},[_c('v-row',[_c('v-col',{staticClass:"white--text",attrs:{"cols":"12"}},[_c('h1',{staticClass:"color:white;"},[_vm._v("This is Dashboard Page")])]),_c('v-col',[_c('instagram-feeds')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }